import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../Auth/AuthProvider';
import { PermissionEnum } from '../../types/PermissionEnum';
import { Routes } from '../../utils/Routes';
import './JobProfile.scss';

type JobView = 'details' | 'activity' | 'stages' | 'allocations' | 'loads' | 'map';

interface JobNavigationProps {
    jobId: number | string;
    active?: JobView;
    variant?: 'profile' | 'stage';
    showSandAllocations?: boolean;
    disabled?: boolean;
}

const JobNavigation = ({ jobId, active, variant = 'profile', showSandAllocations, disabled = false }: JobNavigationProps) => {
    const auth = useAuthContext();
    const isCarrier = auth.userHasPermission(PermissionEnum.Carrier);
    const canShowAllocations = !isCarrier && (active === 'allocations' ||
        (showSandAllocations ?? localStorage.getItem('redirectbackto') !== 'carrier'));
    const items: { view: JobView; title: string; href: string; visible: boolean }[] = [
        { view: 'details', title: 'Job Details', href: `${Routes.JOB_PROFILE.route}${jobId}`, visible: true },
        { view: 'activity', title: 'Current Activity', href: `${Routes.JOB_ACTIVITY.route}${jobId}`, visible: true },
        { view: 'stages', title: 'Stage Summary', href: Routes.STAGE_SUMMARY.route.replace(':jobId', String(jobId)), visible: !isCarrier },
        { view: 'allocations', title: 'Sand Allocations', href: `${Routes.DAILY_SAND_ALLOCATIONS.route}${jobId}`, visible: canShowAllocations },
        { view: 'map', title: 'Map', href: '', visible: active === 'map' },
        { view: 'loads', title: 'Loads', href: `${Routes.JOB_LOADS.route}${jobId}`, visible: true },
    ];
    const visibleItems = items.filter(item => item.visible);

    return <nav aria-label="Job navigation" className={variant === 'stage'
        ? 'StageSummary-JobNavigation' : 'Row JobProfile-ToggleButtonsContainer JobProfile-JobNavigation'}>
        {visibleItems.map((item, index) => {
            const selected = item.view === active;
            const blocked = disabled && !selected;
            const position = index === 0 ? 'Left' : index === visibleItems.length - 1 ? 'Right' : 'Center';
            return <Link key={item.view} to={item.href} aria-current={selected ? 'page' : undefined}
                aria-disabled={blocked || undefined} tabIndex={blocked ? -1 : undefined}
                onClick={event => { if (blocked) event.preventDefault(); }}
                className={variant === 'stage' ? undefined : `JobProfile-${position}ToggleButton JobProfile-ButtonText${
                    selected ? ' JobProfile-ActiveButton' : ''}${blocked ? ' JobProfile-RightToggleButton-Disabled' : ''}`}>
                {item.title}
            </Link>;
        })}
    </nav>;
};

export default JobNavigation;